import React, { useState } from 'react';
import { CheckCircle2Icon, SendIcon } from 'lucide-react';
type FormValues = {
  name: string;
  email: string;
  phone: string;
  service: string;
  message: string;
};
const initialValues: FormValues = {
  name: '',
  email: '',
  phone: '',
  service: '',
  message: ''
};
export function ContactForm() {
  const [values, setValues] = useState<FormValues>(initialValues);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!values.name || !values.email || !values.service || !values.message) {
      setError('Completá los campos requeridos para que podamos contactarte.');
      return;
    }
    if (!/^\S+@\S+\.\S+$/.test(values.email)) {
      setError('Ingresá un email válido.');
      return;
    }
    setError('');
    setSent(true);
    setValues(initialValues);
  }
  const inputClass = 'w-full rounded-lg border border-[#1E2D45] bg-[#0D1117] px-4 py-3.5 text-sm text-white outline-none transition placeholder:text-slate-600 focus:border-[#1D6FE8] focus:ring-2 focus:ring-[#1D6FE8]/30';
  if (sent) {
    return <div className="flex min-h-[430px] flex-col items-center justify-center rounded-2xl border border-[#1D6FE8]/40 bg-[#111827] p-8 text-center" data-id="element-1">
        <CheckCircle2Icon className="h-12 w-12 text-[#1D6FE8]" aria-hidden="true" data-id="element-2" />
        <h3 className="mt-5 text-2xl font-semibold text-white" data-id="element-3">
          Mensaje recibido
        </h3>
        <p className="mt-3 max-w-sm text-sm leading-6 text-[#94A3B8]" data-id="element-4">
          Gracias por escribirnos. El equipo de Vivo Media te responderá a la
          brevedad.
        </p>
        <button onClick={() => setSent(false)} className="mt-7 text-sm font-semibold text-[#1D6FE8] underline underline-offset-4" data-id="element-5">
          Enviar otra consulta
        </button>
      </div>;
  }
  return <form onSubmit={handleSubmit} noValidate className="rounded-2xl border border-[#1E2D45] bg-[#111827] p-6 shadow-2xl shadow-black/30 sm:p-8" data-id="element-6">
      <div className="grid gap-5 sm:grid-cols-2" data-id="element-7">
        <label className="text-sm font-medium text-slate-200" data-id="element-8">
          Nombre <span className="text-[#1D6FE8]" data-id="element-9">*</span>
          <input value={values.name} onChange={e => setValues({
          ...values,
          name: e.target.value
        })} className={`${inputClass} mt-2`} placeholder="Tu nombre" autoComplete="name" data-id="element-10" />
        </label>
        <label className="text-sm font-medium text-slate-200" data-id="element-11">
          Email <span className="text-[#1D6FE8]" data-id="element-12">*</span>
          <input type="email" value={values.email} onChange={e => setValues({
          ...values,
          email: e.target.value
        })} className={`${inputClass} mt-2`} placeholder="nombre@empresa.com" autoComplete="email" data-id="element-13" />
        </label>
        <label className="text-sm font-medium text-slate-200" data-id="element-14">
          Teléfono
          <input type="tel" value={values.phone} onChange={e => setValues({
          ...values,
          phone: e.target.value
        })} className={`${inputClass} mt-2`} placeholder="+598 00 000 000" autoComplete="tel" data-id="element-15" />
        </label>
        <label className="text-sm font-medium text-slate-200" data-id="element-16">
          Servicio <span className="text-[#1D6FE8]" data-id="element-17">*</span>
          <select value={values.service} onChange={e => setValues({
          ...values,
          service: e.target.value
        })} className={`${inputClass} mt-2 appearance-none`} data-id="element-18">
            <option value="" data-id="element-19">Elegí una opción</option>
            <option data-id="element-20">Cartelería & LED</option>
            <option data-id="element-21">Diseño & Branding</option>
            <option data-id="element-22">Marketing Digital</option>
            <option data-id="element-23">Producción Audiovisual</option>
          </select>
        </label>
      </div>
      <label className="mt-5 block text-sm font-medium text-slate-200" data-id="element-24">
        Mensaje <span className="text-[#1D6FE8]" data-id="element-25">*</span>
        <textarea value={values.message} onChange={e => setValues({
        ...values,
        message: e.target.value
      })} className={`${inputClass} mt-2 min-h-28 resize-y`} placeholder="Contanos sobre tu proyecto..." data-id="element-26" />
      </label>
      {error && <p role="alert" className="mt-4 text-sm text-rose-300" data-id="element-27">
          {error}
        </p>}
      <button type="submit" className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-[#1B3A6B] to-[#1D6FE8] px-5 py-3.5 text-sm font-bold text-white transition hover:brightness-110 focus:outline-none focus:ring-2 focus:ring-[#1D6FE8] focus:ring-offset-2 focus:ring-offset-[#111827]" data-id="element-28">
        Enviar mensaje <SendIcon className="h-4 w-4" aria-hidden="true" data-id="element-29" />
      </button>
    </form>;
}